import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex);
const config = {
    plugins: [createPersistedState()],
    state: {
        isLogin: false,
        username: '',
        userId:'',
        token: 'eyJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJ4dXFpdXNodWFuZyIsInVzZXJJZCI6IjI3NCIsIm5hbWUiOiJ4dXFpdXNodWFuZyIsImV4cCI6MTY1OTM1MTQ1MX0.tI3XlF7MKVxDIM6kxNdgfetkK331sHJfcY4JtcC8pdU87bySgBKg9cSQ8F3X7_gKhUFUEkIZSY-XxzSfeRwppEB2w90N2WJwiZe-C5okjScdvZv6QKPrXBwbiU5jCPyUgOPomB7tWtXXUrnE9peyL6tPfpJDZvnmqoEwYo_RzgE'
    },
    getters: {
        isLogin: state => state.isLogin,
        token: state => state.token,
        username: state => state.username
    },
    mutations: {
        updateLogin(state, payload) {
            state.isLogin = payload;
        },
        updateToken(state, payload) {
            state.token = payload;
        },
        updateUsername(state, payload) {
            state.username = payload;
        }
    },
    actions: {}
}
const store = new Vuex.Store(config);
export default store;